import { baseRoutes } from "helpers/baseRoutes";

/**
 * Define access routes related to transaction management, including paths and icons using baseRoutes from the "helpers/baseRoutes" module.
 * @constant {Object} accessRoute
 */
const accessRoute = {
  TRANSACTION_MANAGEMENT: {
    path: `${baseRoutes.adminBaseRoutes}/transaction-management`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-list" />
      </span>
    ),
  }
};

export default accessRoute;
